import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { firmaAPI, kurumAPI, ilceAPI } from '../api';
import toast from 'react-hot-toast';

export default function FirmaModal({ firma, onClose, onSaved }) {
  const isEdit = !!firma?.id;
  const [kurumlar, setKurumlar] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    sira: '', firma_adi: '', ilce: '', kurum_id: '',
    mail: '', telefon: '', notlar: '',
    ...( firma ? {
      sira: firma.sira || '',
      firma_adi: firma.firma_adi || '',
      ilce: firma.ilce || '',
      kurum_id: firma.kurum_id || '',
      mail: firma.mail || '',
      telefon: firma.telefon || '',
      notlar: firma.notlar || '',
    } : {})
  });

  useEffect(() => {
    Promise.all([kurumAPI.list(), ilceAPI.list()]).then(([k, i]) => {
      setKurumlar(k.data);
      setIlceler(i.data);
    });
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.firma_adi.trim()) { toast.error('Firma adı zorunlu'); return; }
    setLoading(true);
    try {
      const payload = {
        ...form,
        sira: form.sira ? parseInt(form.sira) : null,
        kurum_id: form.kurum_id ? parseInt(form.kurum_id) : null,
      };
      if (isEdit) {
        await firmaAPI.update(firma.id, payload);
        toast.success('Firma güncellendi');
      } else {
        await firmaAPI.create(payload);
        toast.success('Firma eklendi');
      }
      onSaved();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 modal-backdrop bg-navy-900/40">
      <div className="modal-content bg-white w-full sm:max-w-lg rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-navy-100">
          <h2 className="font-display text-lg text-navy-800">
            {isEdit ? 'Firmayı Düzenle' : 'Yeni Firma Ekle'}
          </h2>
          <button onClick={onClose} className="btn-ghost p-1.5 -mr-1">
            <X size={18} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="overflow-y-auto flex-1 px-5 py-4 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Sıra No</label>
              <input className="input" type="number" placeholder="1"
                value={form.sira} onChange={(e) => set('sira', e.target.value)} />
            </div>
            <div>
              <label className="label">İlçe / OSB</label>
              <input className="input" list="ilce-list" placeholder="Seç veya yaz"
                value={form.ilce} onChange={(e) => set('ilce', e.target.value)} />
              <datalist id="ilce-list">
                {ilceler.map((i) => <option key={i.id} value={i.ad} />)}
              </datalist>
            </div>
          </div>

          <div>
            <label className="label">Firma Adı <span className="text-rose-500">*</span></label>
            <input className="input" placeholder="Firma adını girin"
              value={form.firma_adi} onChange={(e) => set('firma_adi', e.target.value)} required />
          </div>

          <div>
            <label className="label">İlgili Kurum</label>
            <select className="select" value={form.kurum_id} onChange={(e) => set('kurum_id', e.target.value)}>
              <option value="">— Seçiniz —</option>
              {kurumlar.map((k) => (
                <option key={k.id} value={k.id}>{k.ad}</option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Mail Adresi</label>
              <input className="input" type="email" placeholder="info@firma.com"
                value={form.mail} onChange={(e) => set('mail', e.target.value)} />
            </div>
            <div>
              <label className="label">Telefon</label>
              <input className="input" placeholder="0(212) 000 00 00"
                value={form.telefon} onChange={(e) => set('telefon', e.target.value)} />
            </div>
          </div>

          <div>
            <label className="label">Notlar</label>
            <textarea className="input resize-none" rows={3} placeholder="Not ekleyin…"
              value={form.notlar} onChange={(e) => set('notlar', e.target.value)} />
          </div>
        </form>

        {/* Footer */}
        <div className="flex gap-2 justify-end px-5 py-4 border-t border-navy-100">
          <button type="button" onClick={onClose} className="btn-secondary">İptal</button>
          <button
            onClick={handleSubmit}
            className="btn-primary"
            disabled={loading}
          >
            {loading && <span className="w-3.5 h-3.5 border-2 border-white/40 border-t-white rounded-full animate-spin" />}
            {isEdit ? 'Güncelle' : 'Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}
